// src/components/Layout.js
import React from "react";
import Header from "./Header";
import Home from "./Home";

import "./Layout.css";
//import Map from './Map'
import Footer from "./Footer";
import InfoPopup from "./InfoPopup";

const Layout = ({ onLogout }) => {
  return (
    <div>

<Header onLogout={onLogout} />

      <Home />
      {/* <InfoPopup/> */}
      <Footer/>
      
    </div>
  );
};

export default Layout;
